import http from '../plugins/axios';  
export async function getAllCategory(value){
    let input = {
        type_id: value.type_id,
        type : value.type,
        search : value.search,
        page : value.page,
        limit : value.limit
    }
    const response = await http.get('categories',{params:input});
    return response.data;

}